import React from 'react';
import { ShowToastItem } from './ShowToastItem';
import { ShowErrorItem } from './ShowErrorItem';
import { useToast } from '../contexts/Toast';
import { useError } from '../contexts/Error';

const MainLayout: React.FC = ({ children }): JSX.Element => {
  const ToastContext = useToast();
  const ErrorContext = useError();
  return (
    <main className="content-container">
      {/* <div className="page-container__inner">
      <div className="page-container__main page-container-demo-min-height page-container-outline-blue"> */}
      {children}
      <ShowToastItem
        toast={ToastContext.state.toast}
        onClose={ToastContext.closeToast}
      />
      <ShowErrorItem
        error={ErrorContext.state.error}
        onClose={ErrorContext.closeError}
      />
      {/* </div>
    </div> */}
    </main>
  );
};
export default MainLayout;
